import APICall from './../utils/APICall';

export default class FGBondsServices {

    static CreateFGBondListings = async (data) => {
        return await APICall(`/api/FGNBond/admin/create-fgn-bond-listing`, "POST", data)
    }

    static ListOfBookings = async (pageIndex, pageSize, search, startDate, endDate, status) => {
        let queryString = `/api/FGNBond/admin/fgn-bond-bookings?`;
        if(pageIndex) queryString += `page=${pageIndex}`
         if(pageSize) queryString += `&pageLimit=${pageSize}`
        if (search) queryString += `&search=${search}`;
        if (status) queryString += `&status=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        return await APICall(queryString, "GET")
    }

    static ListOfFGBonds = async (pageIndex, pageSize, search, startDate, endDate, status) => {
        let queryString = `/api/FGNBond/admin/list-fgn-bond-listings?`;
        if(pageIndex) queryString += `page=${pageIndex}`
         if(pageSize) queryString += `&pageLimit=${pageSize}`
        if (search) queryString += `&search=${search}`;
        if (status) queryString += `&status=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        return await APICall(queryString, "GET")
    }

    static getFGBondById = async (id) => {
        return await APICall(`/api/FGNBond/admin/get-fgn-bond-listings/${id}`, "GET")
    }

    static getFGBookingById = async (id) => {
        return await APICall(`/api/FGNBond/admin/get-fgn-bond-bookings/${id}`, "GET")
    }

    static approveRejectFGBond = async (id, action) => {
        return await APICall(`/api/FGNBond/admin/fgn-bond-listing/approve-or-reject`, "POST", {
            fgnBondListingID: id,
            status: action
        })
    }
   
    
    static updateFGBondListings = async (data) => {
        return await APICall(`/api/FGNBond/admin/update-fgn-bond-listing`, "PUT", data)
    }

    static resendBookingAdvise = async (bookingId) => {
        return await APICall(`/api/FGNBond/admin/resend-booking-advise?fgnBondBookingId=${bookingId}`, "GET")
    }

    static deactivateBooking = async (bookingId) => {
        return await APICall(`/api/FGNBond/admin/fgn-bond-listing/deactivate/${bookingId}`, "PATCH")
    }
    static exportFGBookings = async (search, startDate, endDate, status) => {
        let queryString = `/api/FGNBond/admin/export-fgn-bond-bookings?`;
        
        if (search) queryString += `search=${search}`;
        if (status) queryString += `&status=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        return await APICall(queryString, "GET")
    }

    static exportFGBonds = async (search, startDate, endDate, status) => {
        let queryString = `/api/FGNBond/admin/export-fgn-bond-listings?`;
        
        if (search) queryString += `search=${search}`;
        if (status) queryString += `&status=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        return await APICall(queryString, "GET")
    }

    // Eligibility Questions CRUD Operations
    static createEligibilityQuestion = async (data) => {
        return await APICall(`/api/FGNBond/admin/create-fgn-bond-eligibility-question`, "POST", data)
    }

    static getEligibilityQuestions = async () => {
        return await APICall(`/api/FGNBond/admin/eligibility-questions`, "GET")
    }

    static updateEligibilityQuestion = async (data) => {
        return await APICall(`/api/FGNBond/admin/update-fgn-bond-eligibility-question`, "PUT", data)
    }

    static deactivateEligibilityQuestion = async (questionId) => {
        return await APICall(`/api/FGNBond/admin/fgn-bond-eligibility-question/deactivate/${questionId}`, "PATCH")
    }

    static listResponses = async (pageIndex, pageSize, search, fgnBondEligibilityQuestionId) => {
        let queryString = `/api/FGNBond/admin/fgn-bond-eligibility-question/list-responses?`;
        if(pageIndex) queryString += `page=${pageIndex}`
        if(pageSize) queryString += `&pageLimit=${pageSize}`
        if (search) queryString += `&search=${search}`;
        if (fgnBondEligibilityQuestionId) queryString += `&FGNBondEligibilityQuestionId=${fgnBondEligibilityQuestionId}`;
        return await APICall(queryString, "GET")
    }
}
